// extracted by mini-css-extract-plugin
export default {"conversationContainer":"styles_conversationContainer__4REGJ"};